import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ProjectActionTypes } from '../../redux/project/project.types';
import { DefinitionsActionTypes } from '../../redux/definitions/definitions.types';
import Header from '../../components/header/header.component';
import Footer from '../../components/footer/footer.component';
import '../../App.css';
import './step4.styles.scss';
import RadioButton from '../../components/radiobutton/radiobutton.component';
import Button from '../../components/button/button.component';
import { showWarningLayer } from '../../utils/utils';

class Step4 extends React.Component{

  constructor(props){
    super(props);
    this.state = {
      baglantiAdi:'',
      links: (!Array.isArray(this.props.step4.links) || this.props.step4.links === null || this.props.step4.links === undefined) ? [] : this.props.step4.links
    };
    this.handleMedyaVarmi = this.handleMedyaVarmi.bind(this);
    this.handleKonferansVarmi = this.handleKonferansVarmi.bind(this);
    this.handleBaglantiChange = this.handleBaglantiChange.bind(this);
    this.addToLinks = this.addToLinks.bind(this);
    this.removeItem = this.removeItem.bind(this);
  }

  handleMedyaVarmi(event){
    this.props.setStep4({
      ...this.props.step4,
      medyavarmi: event.target.value,
    });
  }  

  handleKonferansVarmi(event){
    this.props.setStep4({
      ...this.props.step4,
      konferansvarmi: event.target.value,
    });
  }    

  handleBaglantiChange(event){
    this.setState({
      ...this.state,
      baglantiAdi: event.target.value
    })
  }

  addToLinks(){
    let newLink = this.state.baglantiAdi;
    if (newLink.length < 10){
      const warnmessage = this.props.language.keywords.lutfenGecerliBirBaglantiGirin;
      this.props.onWarning({warningMessageType:'fail', warningMessageText: warnmessage});      
      showWarningLayer();
      return;
    }

    const newArray = this.state.links.slice();    
    newArray.push(newLink);

    this.setState({
      ...this.state,
      links: newArray,
      baglantiAdi:''
    });

    this.props.setStep4({
      ...this.props.step4,
      links:newArray
    })      
  }

  removeItem(item,index){
    const newList = [...this.state.links];
    var tmpIndex = newList.indexOf(item);
    if (tmpIndex !== -1){
      newList.splice(index,1);
      this.setState({
        ...this.state,
        links: newList
      })
      this.props.setStep4({
        ...this.props.step4,
        links:newList,
      })      

    }
  }



  componentDidMount(){
    this.props.setCurrent('step-4');
    window.scrollTo(0,0);
  } 
  render(){
    return(
      <React.Fragment>
        <section className="sectionStepNew">
          <Header currentPage="step-4" />
          <div className="sectionWrapperNew">
            <div className="gridWrapperNew4">
              <div>
                <h4 className="sectionTitle">{this.props.language.keywords.medyaDeneyiminizVarMi}</h4>
                <div className="medyaDeneyimiRadioWrapper">
                  <div name="medyaDeneyimi" className="medyaDeneyimiRadioGroup" onChange={this.handleMedyaVarmi}>
                    <RadioButton name="checkMedyaDeneyimi" defaultCheck={this.props.step4.medyavarmi === "1" ? true : false} value="1">{this.props.language.keywords.var.toUpperCase()}</RadioButton>
                    <RadioButton name="checkMedyaDeneyimi" defaultCheck={this.props.step4.medyavarmi === "0" ? true : false} value="0">{this.props.language.keywords.yok.toUpperCase()}</RadioButton>
                  </div>              
                </div>
              </div>
              <div>
                <h4 className="sectionTitle">{this.props.language.keywords.konferansDeneyiminizVarMi}</h4>
                <div className="konferansDeneyimiRadioWrapper">
                  <div name="konferansDeneyimi" className="medyaDeneyimiRadioGroup" onChange={this.handleKonferansVarmi}>
                    <RadioButton name="checkKonferansDeneyimi" defaultCheck={this.props.step4.konferansvarmi === "1" ? true : false} value="1">{this.props.language.keywords.var.toUpperCase()}</RadioButton>
                    <RadioButton name="checkKonferansDeneyimi" defaultCheck={this.props.step4.konferansvarmi === "0" ? true : false} value="0">{this.props.language.keywords.yok.toUpperCase()}</RadioButton>
                  </div>              

                </div>
              </div>
              <div>
                <h4 className="sectionTitle tlast">{this.props.language.keywords.ilgiliYayinVeReferansBaglantilari}</h4>
                <p className="linkInfo">{this.props.language.keywords.yayinYoutube}<br/> {this.props.language.keywords.baglantisiEkleyebilirsiniz}</p>
                <div className="baglantiWrapper">
                  <input type="text" placeholder={this.props.language.keywords.baglantiAdresiGirin} className="edits-login" value={this.state.baglantiAdi} onChange={this.handleBaglantiChange} />
                  <Button className="btn-save-new" onClick={this.addToLinks}>{this.props.language.keywords.ekle}</Button>
                </div>
                <div className="componentWrapper step4-layer1">
                  <div className="contentInfoWrapper gorus-konular step4GorusKonular">
                    <ul className="ulYayinReferanslar">
                    {
                      this.state.links.map((item,index)=>(
                        <li key={index} title={item}><button className="btn-remove-list" onClick={() => this.removeItem(item,index)} ></button><span>{item}</span></li>
                      ))
                    }
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>          
          <Footer currentPage="step-4" parentPage="step-3" />
        </section>
      </React.Fragment>      

      
    );
  }
}

const mapStateToProps = state => {
  return {
    step4: state.definitions.step4,
    warningMessage: state.project.warningMessageText,
    warningType: state.project.warningMessageType,
    currentPage: state.project.currentPage,
    language: state.project.language
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onWarning: (payload) => dispatch({ type: ProjectActionTypes.SET_WARNING_MESSAGE, payload: payload}),
    setDefault: () => dispatch({ type: ProjectActionTypes.SET_DEFAULT}),
    setStep4: (step4) => dispatch({ type: DefinitionsActionTypes.SET_STEP4, step4: step4}),
    setCurrent: (value) => dispatch({type: ProjectActionTypes.SET_CURRENT, value: value })
  }
}

export default connect(mapStateToProps,mapDispatchToProps)(withRouter(Step4));